webpackJsonp([93926664682812],{

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 738:
/***/ (function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	'use strict';
	
	exports.match = matchQuery;
	exports.parse = parseQuery;
	
	// -----------------------------------------------------------------------------
	
	var RE_MEDIA_QUERY     = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i,
	    RE_MQ_EXPRESSION   = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/,
	    RE_MQ_FEATURE      = /^(?:(min|max)-)?(.+)/,
	    RE_LENGTH_UNIT     = /(em|rem|px|cm|mm|in|pt|pc)?$/,
	    RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;
	
	function matchQuery(mediaQuery, values) {
	    return parseQuery(mediaQuery).some(function (query) {
	        var inverse = query.inverse;
	
	        // Either the parsed or specified `type` is "all", or the types must be
	        // equal for a match.
	        var typeMatch = query.type === 'all' || values.type === query.type;
	
	        // Quit early when `type` doesn't match, but take "not" into account.
	        if ((typeMatch && inverse) || !(typeMatch || inverse)) {
	            return false;
	        }
	
	        var expressionsMatch = query.expressions.every(function (expression) {
	            var feature  = expression.feature,
	                modifier = expression.modifier,
	                expValue = expression.value,
	                value    = values[feature];
	
	            // Missing or falsy values don't match.
	            if (!value) { return false; }
	
	            switch (feature) {
	                case 'orientation':
	                case 'scan':
	                    return value.toLowerCase() === expValue.toLowerCase();
	
	                case 'width':
	                case 'height':
	                case 'device-width':
	                case 'device-height':
	                    expValue = toPx(expValue);
	                    value    = toPx(value);
	                    break;
	
	                case 'resolution':
	                    expValue = toDpi(expValue);
	                    value    = toDpi(value);
	                    break;
	
	                case 'aspect-ratio':
	                case 'device-aspect-ratio':
	                case /* Deprecated */ 'device-pixel-ratio':
	                    expValue = toDecimal(expValue);
	                    value    = toDecimal(value);
	                    break;
	
	                case 'grid':
	                case 'color':
	                case 'color-index':
	                case 'monochrome':
	                    expValue = parseInt(expValue, 10) || 1;
	                    value    = parseInt(value, 10) || 0;
	                    break;
	            }
	
	            switch (modifier) {
	                case 'min': return value >= expValue;
	                case 'max': return value <= expValue;
	                default   : return value === expValue;
	            }
	        });
	
	        return (expressionsMatch && !inverse) || (!expressionsMatch && inverse);
	    });
	}
	
	function parseQuery(mediaQuery) {
	    return mediaQuery.split(',').map(function (query) {
	        query = query.trim();
	
	        var captures    = query.match(RE_MEDIA_QUERY),
	            modifier    = captures[1],
	            type        = captures[2],
	            expressions = captures[3] || '',
	            parsed      = {};
	
	        parsed.inverse = !!modifier && modifier.toLowerCase() === 'not';
	        parsed.type    = type ? type.toLowerCase() : 'all';
	
	        // Split expressions into a list.
	        expressions = expressions.match(/\([^\)]+\)/g) || [];
	
	        parsed.expressions = expressions.map(function (expression) {
	            var captures = expression.match(RE_MQ_EXPRESSION),
	                feature  = captures[1].toLowerCase().match(RE_MQ_FEATURE);
	
	            return {
	                modifier: feature[1],
	                feature : feature[2],
	                value   : captures[2]
	            };
	        });
	
	        return parsed;
	    });
	}
	
	// -- Utilities ----------------------------------------------------------------
	
	function toDecimal(ratio) {
	    var decimal = Number(ratio),
	        numbers;
	
	    if (!decimal) {
	        numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/);
	        decimal = numbers[1] / numbers[2];
	    }
	
	    return decimal;
	}
	
	function toDpi(resolution) {
	    var value = parseFloat(resolution),
	        units = String(resolution).match(RE_RESOLUTION_UNIT)[1];
	
	    switch (units) {
	        case 'dpcm': return value / 2.54;
	        case 'dppx': return value * 96;
	        default    : return value;
	    }
	}
	
	function toPx(length) {
	    var value = parseFloat(length),
	        units = String(length).match(RE_LENGTH_UNIT)[1];
	
	    switch (units) {
	        case 'em' : return value * 16;
	        case 'rem': return value * 16;
	        case 'cm' : return value * 96 / 2.54;
	        case 'mm' : return value * 96 / 2.54 / 10;
	        case 'in' : return value * 96;
	        case 'pt' : return value * 72;
	        case 'pc' : return value * 72 / 12;
	        default   : return value;
	    }
	}


/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * Date Format 1.2.3
	 * (c) 2007-2009 Steven Levithan <stevenlevithan.com>
	 * MIT license
	 *
	 * Includes enhancements by Scott Trenda <scott.trenda.net>
	 * and Kris Kowal <cixar.com/~kris.kowal/>
	 *
	 * Accepts a date, a mask, or a date and a mask.
	 * Returns a formatted version of the given date.
	 * The date defaults to the current date/time.
	 * The mask defaults to dateFormat.masks.default.
	 */
	
	(function(global) {
	  'use strict';
	
	  var dateFormat = (function() {
	      var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZWN]|"[^"]*"|'[^']*'/g;
	      var timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g;
	      var timezoneClip = /[^-+\dA-Z]/g;
	  
	      // Regexes and supporting functions are cached through closure
	      return function (date, mask, utc, gmt) {
	  
	        // You can't provide utc if you skip other args (use the 'UTC:' mask prefix)
	        if (arguments.length === 1 && kindOf(date) === 'string' && !/\d/.test(date)) {
	          mask = date;
	          date = undefined;
	        }
	  
	        date = date || new Date;
	  
	        if(!(date instanceof Date)) {
	          date = new Date(date);
	        }
	  
	        if (isNaN(date)) {
	          throw TypeError('Invalid date');
	        }
	  
	        mask = String(dateFormat.masks[mask] || mask || dateFormat.masks['default']);
	  
	        // Allow setting the utc/gmt argument via the mask
	        var maskSlice = mask.slice(0, 4);
	        if (maskSlice === 'UTC:' || maskSlice === 'GMT:') {
	          mask = mask.slice(4);
	          utc = true;
	          if (maskSlice === 'GMT:') {
	            gmt = true;
	          }
	        }
	  
	        var _ = utc ? 'getUTC' : 'get';
	        var d = date[_ + 'Date']();
	        var D = date[_ + 'Day']();
	        var m = date[_ + 'Month']();
	        var y = date[_ + 'FullYear']();
	        var H = date[_ + 'Hours']();
	        var M = date[_ + 'Minutes']();
	        var s = date[_ + 'Seconds']();
	        var L = date[_ + 'Milliseconds']();
	        var o = utc ? 0 : date.getTimezoneOffset();
	        var W = getWeek(date);
	        var N = getDayOfWeek(date);
	        var flags = {
	          d:    d,
	          dd:   pad(d),
	          ddd:  dateFormat.i18n.dayNames[D],
	          dddd: dateFormat.i18n.dayNames[D + 7],
	          m:    m + 1,
	          mm:   pad(m + 1),
	          mmm:  dateFormat.i18n.monthNames[m],
	          mmmm: dateFormat.i18n.monthNames[m + 12],
	          yy:   String(y).slice(2),
	          yyyy: y,
	          h:    H % 12 || 12,
	          hh:   pad(H % 12 || 12),
	          H:    H,
	          HH:   pad(H),
	          M:    M,
	          MM:   pad(M),
	          s:    s,
	          ss:   pad(s),
	          l:    pad(L, 3),
	          L:    pad(Math.round(L / 10)),
	          t:    H < 12 ? dateFormat.i18n.timeNames[0] : dateFormat.i18n.timeNames[1],
	          tt:   H < 12 ? dateFormat.i18n.timeNames[2] : dateFormat.i18n.timeNames[3],
	          T:    H < 12 ? dateFormat.i18n.timeNames[4] : dateFormat.i18n.timeNames[5],
	          TT:   H < 12 ? dateFormat.i18n.timeNames[6] : dateFormat.i18n.timeNames[7],
	          Z:    gmt ? 'GMT' : utc ? 'UTC' : (String(date).match(timezone) || ['']).pop().replace(timezoneClip, ''),
	          o:    (o > 0 ? '-' : '+') + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
	          S:    ['th', 'st', 'nd', 'rd'][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10],
	          W:    W,
	          N:    N
	        };
	  
	        return mask.replace(token, function (match) {
	          if (match in flags) {
	            return flags[match];
	          }
	          return match.slice(1, match.length - 1);
	        });
	      };
	    })();
	
	  dateFormat.masks = {
	    'default':               'ddd mmm dd yyyy HH:MM:ss',
	    'shortDate':             'm/d/yy',
	    'mediumDate':            'mmm d, yyyy',
	    'longDate':              'mmmm d, yyyy',
	    'fullDate':              'dddd, mmmm d, yyyy',
	    'shortTime':             'h:MM TT',
	    'mediumTime':            'h:MM:ss TT',
	    'longTime':              'h:MM:ss TT Z',
	    'isoDate':               'yyyy-mm-dd',
	    'isoTime':               'HH:MM:ss',
	    'isoDateTime':           'yyyy-mm-dd\'T\'HH:MM:sso',
	    'isoUtcDateTime':        'UTC:yyyy-mm-dd\'T\'HH:MM:ss\'Z\'',
	    'expiresHeaderFormat':   'ddd, dd mmm yyyy HH:MM:ss Z'
	  };
	
	  // Internationalization strings
	  dateFormat.i18n = {
	    dayNames: [
	      'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat',
	      'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
	    ],
	    monthNames: [
	      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
	      'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
	    ],
	    timeNames: [
	      'a', 'p', 'am', 'pm', 'A', 'P', 'AM', 'PM'
	    ]
	  };
	
	function pad(val, len) {
	  val = String(val);
	  len = len || 2;
	  while (val.length < len) {
	    val = '0' + val;
	  }
	  return val;
	}
	
	/**
	 * Get the ISO 8601 week number
	 * Based on comments from
	 * http://techblog.procurios.nl/k/n618/news/view/33796/14863/Calculate-ISO-8601-week-and-year-in-javascript.html
	 *
	 * @param  {Object} `date`
	 * @return {Number}
	 */
	function getWeek(date) {
	  // Remove time components of date
	  var targetThursday = new Date(date.getFullYear(), date.getMonth(), date.getDate());
	
	  // Change date to Thursday same week
	  targetThursday.setDate(targetThursday.getDate() - ((targetThursday.getDay() + 6) % 7) + 3);
	
	  // Take January 4th as it is always in week 1 (see ISO 8601)
	  var firstThursday = new Date(targetThursday.getFullYear(), 0, 4);
	
	  // Change date to Thursday same week
	  firstThursday.setDate(firstThursday.getDate() - ((firstThursday.getDay() + 6) % 7) + 3);
	
	  // Check if daylight-saving-time-switch occurred and correct for it
	  var ds = targetThursday.getTimezoneOffset() - firstThursday.getTimezoneOffset();
	  targetThursday.setHours(targetThursday.getHours() - ds);
	
	  // Number of weeks between target Thursday and first Thursday
	  var weekDiff = (targetThursday - firstThursday) / (86400000*7);
	  return 1 + Math.floor(weekDiff);
	}
	
	/**
	 * Get ISO-8601 numeric representation of the day of the week
	 * 1 (for Monday) through 7 (for Sunday)
	 * 
	 * @param  {Object} `date`
	 * @return {Number}
	 */
	function getDayOfWeek(date) {
	  var dow = date.getDay();
	  if(dow === 0) {
	    dow = 7;
	  }
	  return dow;
	}
	
	/**
	 * kind-of shortcut
	 * @param  {*} val
	 * @return {String}
	 */
	function kindOf(val) {
	  if (val === null) {
	    return 'null';
	  }
	
	  if (val === undefined) {
	    return 'undefined';
	  }
	
	  if (typeof val !== 'object') {
	    return typeof val;
	  }
	
	  if (Array.isArray(val)) {
	    return 'array';
	  }
	
	  return {}.toString.call(val)
	    .slice(8, -1).toLowerCase();
	};
	
	
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return dateFormat;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = dateFormat;
	  } else {
	    global.dateFormat = dateFormat;
	  }
	})(this);


/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(91);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),

/***/ 1613:
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),

/***/ 1614:
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(1621),
	    isArguments = __webpack_require__(1634),
	    isArray = __webpack_require__(102),
	    isBuffer = __webpack_require__(1635),
	    isIndex = __webpack_require__(1626),
	    isTypedArray = __webpack_require__(1636);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),

/***/ 1615:
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(1617),
	    createBaseEach = __webpack_require__(1624);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ }),

/***/ 1616:
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(1625);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),

/***/ 1617:
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(1616),
	    keys = __webpack_require__(1637);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(100),
	    getRawTag = __webpack_require__(158),
	    objectToString = __webpack_require__(159);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),

/***/ 1618:
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(101),
	    isObjectLike = __webpack_require__(119);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),

/***/ 1619:
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(101),
	    isLength = __webpack_require__(383),
	    isObjectLike = __webpack_require__(119);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),

/***/ 1620:
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(1627),
	    nativeKeys = __webpack_require__(1628);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),

/***/ 1621:
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),

/***/ 1622:
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),

/***/ 1623:
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(1633);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ }),

/***/ 1624:
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(382);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ }),

/***/ 1625:
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),

/***/ 146:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(100);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),

/***/ 1626:
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),

/***/ 1627:
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),

/***/ 1628:
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(1630);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),

/***/ 1629:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(146);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(425)(module)))

/***/ }),

/***/ 159:
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),

/***/ 1630:
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(146);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),

/***/ 1631:
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(103),
	    now = __webpack_require__(1638),
	    toNumber = __webpack_require__(1640);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        timeWaiting = wait - timeSinceLastCall;
	
	    return maxing
	      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	      : timeWaiting;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1632);


/***/ }),

/***/ 1632:
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(1613),
	    baseEach = __webpack_require__(1615),
	    castFunction = __webpack_require__(1623),
	    isArray = __webpack_require__(102);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, castFunction(iteratee));
	}
	
	module.exports = forEach;


/***/ }),

/***/ 1633:
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),

/***/ 1634:
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(1618),
	    isObjectLike = __webpack_require__(119);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),

/***/ 102:
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(160),
	    isLength = __webpack_require__(383);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),

/***/ 1635:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(91),
	    stubFalse = __webpack_require__(1639);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(425)(module)))

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(101),
	    isObject = __webpack_require__(103);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),

/***/ 383:
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),

/***/ 103:
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),

/***/ 119:
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(101),
	    isObjectLike = __webpack_require__(119);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),

/***/ 1636:
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(1619),
	    baseUnary = __webpack_require__(1622),
	    nodeUtil = __webpack_require__(1629);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),

/***/ 1637:
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(1614),
	    baseKeys = __webpack_require__(1620),
	    isArrayLike = __webpack_require__(382);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),

/***/ 1638:
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(91);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ }),

/***/ 1639:
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),

/***/ 1640:
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(103),
	    isSymbol = __webpack_require__(112);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),

/***/ 1641:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var staticMatch = __webpack_require__(738).match;
	var dynamicMatch = typeof window !== 'undefined' ? window.matchMedia : null;
	
	// our fake MediaQueryList
	function Mql(query, values){
	  var self = this;
	  if(dynamicMatch){
	    var mql = dynamicMatch.call(window, query);
	    this.matches = mql.matches;
	    this.media = mql.media;
	    // TODO: is there a time it makes sense to remove this listener?
	    mql.addListener(update);
	  } else {
	    this.matches = staticMatch(query, values);
	    this.media = query;
	  }
	
	  this.addListener = addListener;
	  this.removeListener = removeListener;
	
	  function addListener(listener){
	    if(mql){
	      mql.addListener(listener);
	    }
	  }
	
	  function removeListener(listener){
	    if(mql){
	      mql.removeListener(listener);
	    }
	  }
	
	  // update ourselves!
	  function update(evt){
	    self.matches = evt.matches;
	    self.media = evt.media;
	  }
	}
	
	function matchMedia(query, values){
	  return new Mql(query, values);
	}
	
	module.exports = matchMedia;


/***/ }),

/***/ 425:
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BreadcrumbsContainer = __webpack_require__(197);
	
	var _BreadcrumbsContainer2 = _interopRequireDefault(_BreadcrumbsContainer);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cat_map = {
	  'food': {
	    'endpoints': {
	      'enforcement': {
	        'title': 'Recall enforcement reports',
	        'url': '/api_endpoints/food/enforcement/'
	      },
	      'event': {
	        'title': 'Food, dietary supplement, and cosmetic adverse event reports',
	        'url': '/api_endpoints/food/event/'
	      }
	    },
	    'title': 'Foods ',
	    'url': '/api_endpoints/food/'
	  },
	  'device': {
	    'endpoints': {
	      'event': {
	        'title': 'Adverse Event Reports',
	        'url': '/api_endpoints/device/event/'
	      },
	      'classification': {
	        'title': 'Classification',
	        'url': '/api_endpoints/device/classification/'
	      },
	      '510k': {
	        'title': '510(k) clearances',
	        'url': '/api_endpoints/device/510k/'
	      },
	      'pma': {
	        'title': 'Premarket approval',
	        'url': '/api_endpoints/device/pma/'
	      },
	      'registrationlisting': {
	        'title': 'Registrations and listings',
	        'url': '/api_endpoints/device/registrationlisting/'
	      },
	      'recall': {
	        'title': 'Recalls',
	        'url': '/api_endpoints/device/recall/'
	      },
	      'enforcement': {
	        'title': 'Recall enforcement reports',
	        'url': '/api_endpoints/device/enforcement/'
	      },
	      'udi': {
	        'title': 'Unique device identifier',
	        'url': '/api_endpoints/device/udi/'
	      }
	    },
	    'title': 'Medical Devices ',
	    'url': '/api_endpoints/device/'
	  },
	  'drug': {
	    'endpoints': {
	      'enforcement': {
	        'title': 'Recall enforcement reports',
	        'url': '/api_endpoints/drug/enforcement/'
	      },
	      'label': {
	        'title': 'Product labeling',
	        'url': '/api_endpoints/drug/label/'
	      },
	      'event': {
	        'title': 'Adverse events',
	        'url': '/api_endpoints/drug/event/'
	      }
	    },
	    'title': 'Drugs ',
	    'url': '/api_endpoints/drug/'
	  }
	};
	
	// if not on top level page, render breadcrumb nav
	var BreadCrumbs = function BreadCrumbs(props) {
	  var hideDropdownContent = props.hideDropdownContent,
	      showDropdownContent = props.showDropdownContent,
	      toggleDropdownContent = props.toggleDropdownContent,
	      activeDropdown = props.activeDropdown,
	      path = props.path;
	
	  if (typeof window === 'undefined') return _react2.default.createElement('span', null);
	  var crumbs = path.split('/').filter(function (d) {
	    return d;
	  });
	
	  if (crumbs.length === 0) return _react2.default.createElement('span', null);
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'row', style: { background: 'rgba(0, 0, 0, 0.2)' } },
	    _react2.default.createElement(
	      'nav',
	      {
	        'aria-label': 'Breadcrumb navigation.',
	        className: 'container flex-box just-between align-center dir-row clr-gray responsive-header' },
	      _react2.default.createElement(
	        'div',
	        { className: 'breadcrumb' },
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'clr-white pad-r-1',
	            href: '/' },
	          'ftbcAcademy'
	        ),
	        crumbs.map(function (crumb, i) {
	          var isLast = i === crumbs.length - 1;
	
	          // gotta match the url structure of existing site
	          // update => updates
	          var safeCrumb = crumb === 'update' ? 'updates' : crumb;
	
	          // pull url from breadcrumb list
	          // if update, /update/ => /updates/
	          var url = crumbs.slice(0, i + 1).join('/');
	          var safeUrl = url.replace('update', 'updates');
	
	          return _react2.default.createElement(
	            'span',
	            { key: i },
	            _react2.default.createElement(
	              'span',
	              { className: 'clr-white', style: { opacity: '50%' } },
	              '/'
	            ),
	            !isLast ? _react2.default.createElement(
	              'a',
	              {
	                className: 'clr-white pad-r-1 pad-l-1',
	                href: window.location.origin + '/' + safeUrl + '/' },
	              safeCrumb
	            ) : _react2.default.createElement(
	              'span',
	              { className: 'clr-white marg-l-1' },
	              crumb
	            )
	          );
	        })
	      ),
	      path.indexOf('api_endpoints') >= 0 && _react2.default.createElement(
	        'nav',
	        {
	          'aria-label': 'Endpoint navigation.',
	          className: 'flex-box align-center just-center dir-row responsive-header', style: { zIndex: 1 } },
	        Object.keys(cat_map).map(function (cat, i) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'endpoint-dropdown', key: i, onMouseLeave: hideDropdownContent, onMouseEnter: showDropdownContent },
	            _react2.default.createElement(
	              'span',
	              {
	                title: cat,
	                className: 'cat-menu-item ' + (activeDropdown == cat ? 'clr-white' : path.indexOf(cat) >= 0 ? 'clr-white ' : 'clr-muted-white '),
	                onTouchStart: toggleDropdownContent
	              },
	              cat_map[cat]['title'],
	              _react2.default.createElement('i', { className: 'fa fa-angle-down' })
	            ),
	            _react2.default.createElement('div', { className: path.indexOf(cat) >= 0 ? 'cat-menu-underbar' : 'cat-menu-underbar-hidden' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'dropdown-content ' + (activeDropdown == cat ? 'display-block' : 'display-none') },
	              _react2.default.createElement(
	                'div',
	                { className: 'sub-menu-container', role: 'navigation' },
	                Object.keys(cat_map[cat]['endpoints']).map(function (endpoint, ii) {
	                  return _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    {
	                      className: 'sub-menu-item',
	                      key: ii,
	                      to: cat_map[cat]['endpoints'][endpoint]['url']
	                    },
	                    cat_map[cat]['endpoints'][endpoint]['title']
	                  );
	                })
	              )
	            )
	          );
	        })
	      )
	    )
	  );
	};
	
	BreadCrumbs.displayName = 'components/BreadCrumbs';
	exports.default = (0, _BreadcrumbsContainer2.default)(BreadCrumbs);
	module.exports = exports['default'];

/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(10);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SideBar = __webpack_require__(444);
	
	var _SideBar2 = _interopRequireDefault(_SideBar);
	
	var _Hero = __webpack_require__(196);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _SideBarContainer = __webpack_require__(450);
	
	var _SideBarContainer2 = _interopRequireDefault(_SideBarContainer);
	
	var _mapFields = __webpack_require__(465);
	
	var _mapFields2 = _interopRequireDefault(_mapFields);
	
	var _flattenFields = __webpack_require__(464);
	
	var _flattenFields2 = _interopRequireDefault(_flattenFields);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import Content from './Content'
	var wrapperCx = (0, _classnames2.default)({
	  'container marg-b-3 relative row content-wrapper': true
	});
	
	// add fixed positioning functinality to reference sidebar
	
	
	// import EndpointStatus from './EndpointStatus'
	
	
	var ComposedSidebar = (0, _SideBarContainer2.default)(_SideBar2.default);
	
	// i just exist to render the Sidebar, and
	// determine whether we render ref specific
	// components or not
	var ContentWrapper = function ContentWrapper(props) {
	  var content = props.content,
	      explorers = props.explorers,
	      fields = props.fields,
	      infographics = props.infographics,
	      infographicDefinitions = props.infographicDefinitions,
	      meta = props.meta;
	
	
	  var fieldsMapped = {};
	  var fieldsFlattened = {};
	  if (explorers && fields) {
	    fieldsMapped = (0, _mapFields2.default)(fields.properties);
	    fieldsFlattened = (0, _flattenFields2.default)(fieldsMapped);
	  }
	
	  var contentCx = (0, _classnames2.default)({
	    'float-r': true,
	    'ref-content': true
	  });
	
	  //console.log(meta.docType);
	  //console.log(content);
	
	  if (meta.docType != "documentation") {
	    return _react2.default.createElement(
	      'section',
	      null,
	      _react2.default.createElement(_Hero2.default, meta),
	      _react2.default.createElement(
	        'section',
	        { className: wrapperCx },
	        meta.type !== 'update' && _react2.default.createElement(ComposedSidebar, {
	          className: 'm-hide',
	          reference: content
	        }),
	        _react2.default.createElement(
	          'div',
	          {
	            className: contentCx,
	            style: {
	              maxWidth: '100%'
	            } },
	          _react2.default.createElement('div', { className: 'marg-t-2 marg-b-2', dangerouslySetInnerHTML: { __html: content } })
	        )
	      )
	    );
	  } else {
	    return _react2.default.createElement(
	      'section',
	      { className: 'doc-content' },
	      _react2.default.createElement('div', { className: 'marg-b-2', dangerouslySetInnerHTML: { __html: content } })
	    );
	  }
	};
	
	ContentWrapper.displayName = 'components/ContentWrapper';
	ContentWrapper.defaultProps = {
	  showMenu: false
	};
	exports.default = ContentWrapper;
	module.exports = exports['default'];

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(10);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _BC = __webpack_require__(194);
	
	var _BC2 = _interopRequireDefault(_BC);
	
	var _dateformat = __webpack_require__(144);
	
	var _dateformat2 = _interopRequireDefault(_dateformat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description [renders meta data (yaml usually) as the hero el below breadcrumbs]
	 * @param {string|React.Element} description [paragraph below title]
	 * @param {string} label [small text right above the title]
	 * @param {string} path [the page route, for endpoint pages]
	 * @param {string} title [the title, used on non-endpoint pages (posts, etc)]
	 * @param {string} type [endpoint or not, used for styling and tabs]
	 * @return {React.Element}
	 */
	var Hero = function Hero(props) {
	  var authors = props.authors,
	      date = props.date,
	      description = props.description,
	      htmlDescription = props.htmlDescription,
	      label = props.label,
	      path = props.path,
	      title = props.title,
	      type = props.type;
	
	
	  var heroCx = (0, _classnames2.default)({
	    'flex-box dir-column': true,
	    'bg-gray': type !== 'dataset' && type !== 'endpoint',
	    'bg-primary': type === 'dataset'
	  });
	
	  var bg_image_color = {
	    food: { background: 'linear-gradient(to bottom right, rgba(81, 161, 22, 1), rgba(143, 209, 100, 1))', backgroundSize: 'contain', backgroundPosition: 'right', height: '240px' },
	    device: { background: 'linear-gradient(to right bottom, rgb(232, 92, 44), rgb(236, 169, 6))', backgroundSize: 'contain', backgroundPosition: 'right', height: '240px' },
	    drug: { background: 'linear-gradient(to bottom right, rgba(153, 88, 163, 1), rgba(220, 141, 188, 1))', backgroundSize: 'contain', backgroundPosition: 'right', height: '240px' },
	    animal_and_veterinary: { background: 'linear-gradient(to bottom right, rgba(249, 157, 28, 1), rgba(252, 215, 112, 1))', backgroundSize: 'contain', backgroundPosition: 'right', height: '240px' },
	    other: { backgroundColor: '#5b616b' }
	  };
	  var bg_image = {
	    food: '/img/apple.png',
	    device: '/img/stethoscope.png',
	    drug: '/img/pill-bottle.png',
	    animal_and_veterinary: '/img/dog.png'
	  };
	
	  var bg_image_style = {
	    food: { height: '300px', mixBlendMode: 'multiply', position: 'absolute', right: 0, zoom: '100%', top: '-20px' },
	    device: { height: '300px', mixBlendMode: 'multiply', position: 'absolute', right: 0, zoom: '100%', top: '-30px' },
	    drug: { height: '350px', mixBlendMode: 'multiply', position: 'absolute', right: 0, zoom: '120%', top: '-65px' }
	  };
	
	  if ('path' in props) {
	    var cat_path = path.split('/');
	    var cat_name = cat_path[2];
	  } else {
	    var cat_name = 'other';
	  }
	
	  var desc = description && description.trim();
	
	  return _react2.default.createElement(
	    'section',
	    {
	      id: 'hero' },
	    _react2.default.createElement(
	      'div',
	      {
	        className: heroCx,
	        style: bg_image_color[cat_name] },
	      _react2.default.createElement(_BC2.default, null),
	      _react2.default.createElement(
	        'div',
	        { className: 'hero-text-box container flex-row dir-column pad-t-2 pad-b-2' },
	        type === 'update' && _react2.default.createElement(
	          'span',
	          {
	            tabIndex: 0,
	            className: 'clr-white serif weight-700 small' },
	          (0, _dateformat2.default)(date, 'mmmm d, yyyy')
	        ),
	        _react2.default.createElement(
	          'h2',
	          {
	            tabIndex: label ? -1 : 0,
	            className: 'clr-white weight-700 header-width' },
	          title
	        ),
	        type != 'update' && _react2.default.createElement('div', { className: 'hero-divider-line' }),
	        desc && htmlDescription && _react2.default.createElement('p', {
	          tabIndex: 0,
	          className: 'subtitle clr-white font-size-4 header-width',
	          dangerouslySetInnerHTML: { __html: desc } }),
	        desc && !htmlDescription && _react2.default.createElement(
	          'p',
	          { tabIndex: 0, className: 'subtitle clr-white font-size-4 header-width' },
	          desc
	        ),
	        authors && authors.map(function (author, i) {
	          return _react2.default.createElement(
	            'p',
	            { tabIndex: i, key: i, className: 'subtitle clr-white font-size-4 header-width' },
	            author
	          );
	        })
	      ),
	      _react2.default.createElement('img', { src: bg_image[cat_name], style: bg_image_style[cat_name] })
	    )
	  );
	};
	
	Hero.displayName = 'components/Hero';
	// using defaultProps just because it gets a little unwiedly up there
	Hero.defaultProps = {
	  description: '',
	  type: 'landing',
	  htmlDescription: false
	};
	exports.default = Hero;
	module.exports = exports['default'];

/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(10);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _breakpoints = __webpack_require__(449);
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description specific endpoint sidebar menus. used only there
	 * @param {Object} [menu] [menu data for interacting with infographics]
	 * @returns React.Element
	 */
	var CustomMenu = function CustomMenu(_ref) {
	  var menu = _ref.menu;
	
	  if (_breakpoints2.default.mob) {
	    return _react2.default.createElement(
	      'label',
	      null,
	      _react2.default.createElement(
	        'span',
	        null,
	        'Select data visualization to view'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'select-wrap marg-b-2' },
	        _react2.default.createElement(
	          'select',
	          {
	            className: 'marg-t-1',
	            selected: menu.selected,
	            onChange: menu.handler },
	          menu.data && menu.data.map(function (d, i) {
	            return _react2.default.createElement(
	              'option',
	              {
	                value: d,
	                key: i },
	              d
	            );
	          })
	        )
	      )
	    );
	  }
	
	  return _react2.default.createElement(
	    'menu',
	    { className: 'dir-column flex-box' },
	    _react2.default.createElement(
	      'span',
	      {
	        className: 'visually-hidden',
	        tabIndex: 0 },
	      'Click buttons to toggle active visualization'
	    ),
	    menu.data && menu.data.map(function (d, i) {
	      var btnCx = (0, _classnames2.default)({
	        'menu-item row': true,
	        'active': d === menu.selected
	      });
	
	      return _react2.default.createElement(
	        'button',
	        {
	          className: btnCx,
	          key: i,
	          onClick: menu.handler },
	        d
	      );
	    })
	  );
	};
	
	CustomMenu.displayName = 'components/SideBar/CustomMenu';
	exports.default = CustomMenu;
	module.exports = exports['default'];

/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(10);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CustomMenu = __webpack_require__(443);
	
	var _CustomMenu2 = _interopRequireDefault(_CustomMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description [sidebar for endpoint basics and reference pages]
	 *              [important: is not always composed by SidebarContainer]
	 *              [this means it can have different functionality]
	 *              [depending on it's end use (sticky vs non-sticky)]
	 */
	
	// import ReferenceMenu from './ReferenceMenu'
	// import DownloadsMenu from './DownloadsMenu'
	var SideBar = function SideBar(props) {
	  var _cx;
	
	  var bottom = props.bottom,
	      bottomPos = props.bottomPos,
	      bp = props.bp,
	      className = props.className,
	      downloads = props.downloads,
	      fixed = props.fixed,
	      menu = props.menu,
	      reference = props.reference,
	      style = props.style;
	
	
	  var sideBarCx = (0, _classnames2.default)({
	    'sb-fixed': fixed
	
	  });
	
	  var wrapCx = (0, _classnames2.default)((_cx = {
	    'relative col sb m-marg-t-3 m-marg-b-2': true
	  }, _cx[className] = !!className, _cx));
	
	  // aside === relative position, holds sidebar in place
	  // inner div === if sidebar is sticky, this is what moves
	
	  return _react2.default.createElement(
	    'aside',
	    {
	      id: 'sidebarWrap',
	      className: wrapCx,
	      style: _extends({}, style, {
	        maxWidth: '300px'
	      }) },
	    _react2.default.createElement(
	      'div',
	      { className: sideBarCx },
	      menu && _react2.default.createElement(_CustomMenu2.default, {
	        bp: bp,
	        menu: menu
	      })
	    )
	  );
	};
	
	SideBar.displayName = 'components/Sidebar';
	exports.default = SideBar;
	module.exports = exports['default'];

/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _matchmedia = __webpack_require__(1641);
	
	var _matchmedia2 = _interopRequireDefault(_matchmedia);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isMob = true;
	
	var isTab = false;
	var isDesk = false;
	var isWide = false;
	
	if (typeof window !== 'undefined') {
	  var _getBreakpointsOnResize = function _getBreakpointsOnResize() {
	    isMob = (0, _matchmedia2.default)('(max-width: 640px)').matches;
	    isTab = (0, _matchmedia2.default)('(min-width: 641px)').matches;
	    isDesk = (0, _matchmedia2.default)('(min-width: 1024px)').matches;
	    isWide = (0, _matchmedia2.default)('(min-width: 1400px)').matches;
	  };
	
	  _getBreakpointsOnResize();
	  window.onresize = _getBreakpointsOnResize;
	}
	
	exports.default = {
	  mob: isMob,
	  tab: isTab,
	  desk: isDesk,
	  wide: isWide
	};
	module.exports = exports['default'];

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BreadcrumbsContainer = function BreadcrumbsContainer(ComposedBreadcrumbs) {
	  var HOC = function (_React$Component) {
	    _inherits(HOC, _React$Component);
	
	    function HOC() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, HOC);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	        showMobileNav: false,
	        activeDropdown: ' ',
	        path: ' '
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    HOC.prototype.componentDidMount = function componentDidMount() {
	      this.setState({
	        path: window.location.pathname
	      });
	    };
	
	    HOC.prototype._toggleDropdownContent = function _toggleDropdownContent(e) {
	      var title = e.target.getAttribute('title');
	      if (this.state.activeDropdown != title) {
	        this.setState({
	          activeDropdown: title
	        });
	      } else {
	        this.setState({
	          activeDropdown: ' '
	        });
	      }
	    };
	
	    HOC.prototype._hideDropdownContent = function _hideDropdownContent() {
	      if (this.state.showMobileNav == false) {
	        this.setState({
	          activeDropdown: ' '
	        });
	      }
	    };
	
	    HOC.prototype._showDropdownContent = function _showDropdownContent(e) {
	      if (this.state.showMobileNav == false) {
	        var title = e.target.getAttribute('title');
	        this.setState({
	          activeDropdown: title
	        });
	      }
	    };
	
	    HOC.prototype.render = function render() {
	      return _react2.default.createElement(ComposedBreadcrumbs, _extends({}, this.props, this.state, {
	        toggleDropdownContent: this._toggleDropdownContent.bind(this),
	        hideDropdownContent: this._hideDropdownContent.bind(this),
	        showDropdownContent: this._showDropdownContent.bind(this)
	      }));
	    };
	
	    return HOC;
	  }(_react2.default.Component);
	
	  return HOC;
	};
	
	exports.default = BreadcrumbsContainer;
	module.exports = exports['default'];

/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _debounce = __webpack_require__(1631);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SideBarContainer = function SideBarContainer(ComposedSideBar) {
	  var HOC = function (_React$Component) {
	    _inherits(HOC, _React$Component);
	
	    function HOC(props) {
	      _classCallCheck(this, HOC);
	
	      // debounce so we're not calling this functions
	      // thousands of times a second
	      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	      _this.state = {
	        bottom: false,
	        fixed: false
	      };
	      _this._boundCheckPosition = {};
	      _this._boundCheckPosition = (0, _debounce2.default)(_this._checkPosition.bind(_this), 10);
	      return _this;
	    }
	
	    // this just gets re-assigned in constructor
	    // for flow purposes
	
	
	    HOC.prototype.componentDidMount = function componentDidMount() {
	      var boundCB = this._boundCheckPosition;
	
	      if (window) {
	        window.addEventListener('scroll', boundCB, false);
	        window.addEventListener('resize', boundCB);
	      }
	    };
	
	    HOC.prototype.componentWillUnmount = function componentWillUnmount() {
	      var boundCB = this._boundCheckPosition;
	
	      if (window) {
	        window.removeEventListener('scroll', boundCB, false);
	        window.removeEventListener('resize', boundCB);
	      }
	    };
	
	    HOC.prototype._checkPosition = function _checkPosition() {
	      // the entire aside, the height of the height
	      var wrap = document.getElementById('sidebarWrap');
	      // the actual menu, of variable height, that can be fixed
	      var el = document.getElementById('menu');
	      // footer height, used for bottom positioning
	      var footer = document.getElementById('footer');
	      // height of footer with spacing - menu padding
	      var bottomPos = footer.clientHeight + 50;
	      // the top position of the wrapper
	      var runwayStart = this._getPos(wrap);
	      // the bottom position of the wrapper, the end of the runway
	      var runwayEnd = wrap.clientHeight;
	      // current browser scroll position
	      var browser = this._getPageScroll();
	      // browser position - content above sidebar
	      var realPos = browser - runwayStart;
	
	      // don't do anything if at the top of the page
	      if (browser <= runwayStart - 45 && !this.state.fixed) {
	        return;
	      }
	
	      // we're within the 'runway'
	      if (browser > runwayStart - 45) {
	        // we fix the nav once the browser is past starting point
	        var _fixed = true;
	        // we're at the end of the runway
	        var _bottom = false;
	        var elementBottomPos = realPos + el.clientHeight;
	
	        // account for the 85px spacer at the bottom
	        if (elementBottomPos >= runwayEnd - 85) {
	          _bottom = true;
	          _fixed = false;
	        }
	
	        return this.setState({
	          bottomPos: bottomPos,
	          bottom: _bottom,
	          fixed: _fixed
	        });
	      }
	
	      this.setState({
	        fixed: false
	      });
	    };
	
	    // findPos() by quirksmode.org
	    // Finds the absolute position of an element on a page
	
	
	    HOC.prototype._getPos = function _getPos(element) {
	      var absPos = 0;
	      var el = element;
	
	      while (el.offsetParent) {
	        absPos += el.offsetTop;
	
	        if (el === document.getElementsByTagName('body')[0]) {
	          break;
	        } else {
	          el = el.offsetParent;
	        }
	      }
	
	      return absPos;
	    };
	
	    // getPageScroll() by quirksmode.org
	    // Finds the scroll position of a page
	
	
	    HOC.prototype._getPageScroll = function _getPageScroll() {
	      var browserPos = 0;
	
	      if (self.pageYOffset) {
	        browserPos = self.pageYOffset;
	      } else if (document.documentElement && document.documentElement.scrollTop) {
	        browserPos = document.documentElement.scrollTop;
	      }
	      // all other Browsers
	      else if (document.body) {
	          browserPos = document.body.scrollTop;
	        }
	
	      return browserPos;
	    };
	
	    HOC.prototype.render = function render() {
	      return _react2.default.createElement(ComposedSideBar, _extends({}, this.props, this.state));
	    };
	
	    return HOC;
	  }(_react2.default.Component);
	
	  return HOC;
	};
	
	exports.default = SideBarContainer;
	module.exports = exports['default'];

/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	exports.default = Template;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(442);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Template(_ref) {
	  var data = _ref.data;
	  var markdownRemark = data.markdownRemark; // data.markdownRemark holds our post data
	
	  var frontmatter = markdownRemark.frontmatter,
	      html = markdownRemark.html;
	
	
	  return _react2.default.createElement(
	    'section',
	    null,
	    _react2.default.createElement(_ContentWrapper2.default, { meta: frontmatter, content: html })
	  );
	}
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _each = __webpack_require__(381);
	
	var _each2 = _interopRequireDefault(_each);
	
	var _isObject = __webpack_require__(103);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Completely flatten a nested object into an object with dot-notation
	// Turns the results of getFieldNamesAndChartTypes into a useful object for the infographic explorer UI
	// e.g.
	// {
	//   'report': 'bar',
	//   'date': 'line',
	//   'patient.drug.name': 'bar',
	//   'patient.drug.openfda.brand_name': 'bar',
	//   'patient.drug.openfda.number': 'bar'
	// }
	var completelyFlatten = function completelyFlatten(item) {
	  var result = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var prefix = arguments[2];
	
	
	  if ((0, _isObject2.default)(item)) {
	    (0, _each2.default)(item, function (val, key) {
	      var pre = prefix ? prefix + '.' + key : key;
	      return completelyFlatten(val, result, pre);
	    });
	  } else {
	    result[prefix] = item;
	  }
	
	  return result;
	};
	
	exports.default = completelyFlatten;
	module.exports = exports['default'];

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _each = __webpack_require__(381);
	
	var _each2 = _interopRequireDefault(_each);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Traverses the endpoint field documentation and gets the field names and types
	// e.g.
	// {
	//   report: 'bar',
	//   date: 'line',
	//   patient: {
	//     drug: {
	//       name: 'bar',
	//       openfda: {
	//         brand_name: 'bar',
	//         number: 'bar'
	//       }
	//     }
	//   }
	// }
	var getFieldNamesAndChartTypes = function getFieldNamesAndChartTypes(fields) {
	  var fieldMap = {};
	
	  (0, _each2.default)(fields, function (val, key) {
	    // If this field is one that wants to be counted with .exact
	    // (e.g. a product name field), it needs to be represented with
	    var exactKey = null;
	
	    // recursion if we meet an field with type object
	    if (val.type === 'object' && key !== 'meta') {
	      fieldMap[key] = getFieldNamesAndChartTypes(val.properties);
	      return;
	    }
	
	    // This array contains multi-field objects
	    // e.g. in /drug/event patient.drug is an array of drug objects
	    if (val.type === 'array' && val.items.properties) {
	      fieldMap[key] = getFieldNamesAndChartTypes(val.items.properties);
	      return;
	    }
	
	    var hidden = val.hide || val.items && val.items.hide;
	    if (hidden) {
	      return;
	    }
	
	    // because of recursion
	    // we should be looking at an individual field at this point
	    // if not array/object, checking .is_exact is enough
	    // if array/object, we need to go 1 level deeper
	    var isExact = val.is_exact || val.items && val.items.is_exact;
	    if (isExact) {
	      exactKey = key + '.exact';
	    }
	
	    // Determine what kind of chart we will want to draw based on the field content/data
	    if (val.format === 'date') {
	      fieldMap[key] = 'Line';
	
	      if (isExact) {
	        fieldMap[exactKey] = 'Line';
	      }
	
	      return;
	    }
	
	    if (val.possible_values) {
	      var vals = val.possible_values;
	
	      if (vals.type !== 'one_of') return;
	
	      var isShort = Object.keys(vals.value).length < 10;
	
	      // we only want to use donut charts
	      // when we can easily fit the data
	      if (!isShort) return;
	
	      fieldMap[key] = 'Donut';
	      if (isExact) {
	        fieldMap[exactKey] = 'Donut';
	      }
	
	      return;
	    }
	
	    // N.B. If this array contains a single field, it gets treated like an ordinary field
	    // e.g. in /drug/event patient.drug.openfda.brand_name is an array of strings
	    fieldMap[key] = 'Bar';
	    if (isExact) {
	      fieldMap[exactKey] = 'Bar';
	    }
	  });
	
	  return fieldMap;
	};
	
	exports.default = getFieldNamesAndChartTypes;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-docs-markdown-js-ae10dbdc97fa78f4aeec.js